import { IValidationRule } from "./IValidationRule";
import { IValidationCondition } from "./IValidationCondition";

export class Validator<TValue> {
    private _validationRules: IValidationRule<TValue>[] = [];
    private _previousBrokenValidationRules: IValidationRule<TValue>[] = [];

    public addFromCondition<TConditionValue>(
        condition: IValidationCondition<TConditionValue>,
        funct: (value: TValue, conditionValue: TConditionValue) => boolean
    ): void {
        if (condition && condition.errorMessage) {
            const rule: IValidationRule<TValue> = {
                validator: (value) => funct(value, condition.value),
                errorMessage: condition.errorMessage,
            };

            this._validationRules.push(rule);
        }
    }

    public add(rule: (value: TValue) => boolean, errorMessage: string): void {
        if (errorMessage) {
            this._validationRules.push({ validator: rule, errorMessage });
        }
    }

    public addRange(rules: IValidationRule<TValue>[]): void {
        if (rules) {
            this._validationRules = this._validationRules.concat(rules.filter((rule) => rule != null));
        }
    }

    public clear(): void {
        this._validationRules = [];
    }

    public getValidationErrors(rawValue: TValue): string[] {
        return this.getBrokenValidationRules(rawValue, this._validationRules).map((rule) => rule.errorMessage);
    }

    public getUnresolvedValidationErrors(rawValue: TValue): string[] {
        return this.getBrokenValidationRules(rawValue, this._previousBrokenValidationRules).map(
            (rule) => rule.errorMessage
        );
    }

    private getBrokenValidationRules(rawValue: TValue, rules: IValidationRule<TValue>[]): IValidationRule<TValue>[] {
        const brokenRules: IValidationRule<TValue>[] = rules.slice().filter((rule) => !rule.validator(rawValue));
        this._previousBrokenValidationRules = brokenRules;
        return brokenRules;
    }
}
